import { saneOption } from 'logard';
import { reactive } from 'vue';
import GeneralClient from '../general/client/GeneralClient';
import Permission from '../shared/constants/Permission';
import { ContextLoader } from '../shared/models/AbstractContext';
import { UserId } from '../shared/models/User';
import { extractIds } from '../shared/utils';
import { RESTRICTED_USER_PARAM, RESTRICTED_USER_STORAGE_KEY } from '../shared/utils/filters';
import { saneNumericId } from '../shared/utils/sanitizers';
import { isPresent } from '../shared/utils/typescript';
import AuditAccessClient from './client/AuditAccessClient';
import AuditAccessContext from './models/AuditAccessContext';
import AuditAccessFilters from './models/AuditAccessFilters';

export const auditAccessContextLoader = new ContextLoader(async s => {
  const options = await GeneralClient.loadUsers(Permission.RESTRICTED, false);
  const restrictedUser = s.getQueryParam(RESTRICTED_USER_PARAM, saneOption(extractIds(options), saneNumericId<UserId>), sessionStorage.getItem(RESTRICTED_USER_STORAGE_KEY) ?? undefined) ?? null;
  const filters = new AuditAccessFilters(options, restrictedUser);

  const restrictedAccessRecords = isPresent(filters.activeUserId) ? await AuditAccessClient.getRestrictedAccessRecordsByUser(filters.activeUserId) : [];

  return reactive(new AuditAccessContext(filters, restrictedAccessRecords));
});